import * as Types from '@trello/graphql/generated';

import { useQuickLoad } from '@trello/quickload';
import type { TrelloQueryHookOptions, TrelloLazyQueryHookOptions, TrelloSuspenseQueryHookOptions } from '@trello/quickload';
import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export const BoardJoinButtonMemberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BoardJoinButtonMember"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"member"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"confirmed"}},{"kind":"Field","name":{"kind":"Name","value":"idEnterprisesAdmin"}},{"kind":"Field","name":{"kind":"Name","value":"idPremOrgsAdmin"}},{"kind":"Field","name":{"kind":"Name","value":"memberType"}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"BoardJoinButtonMember","document":BoardJoinButtonMemberDocument}} as const;
export type BoardJoinButtonMemberQueryVariables = Types.Exact<{
  memberId: Types.Scalars['ID']['input'];
}>;


export type BoardJoinButtonMemberQuery = (
  { __typename: 'Query' }
  & { member?: Types.Maybe<(
    { __typename: 'Member' }
    & Pick<Types.Member, 'id' | 'confirmed' | 'idEnterprisesAdmin' | 'idPremOrgsAdmin' | 'memberType'>
  )> }
);

/**
 * __useBoardJoinButtonMemberQuery__
 *
 * To run a query within a React component, call `useBoardJoinButtonMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useBoardJoinButtonMemberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBoardJoinButtonMemberQuery({
 *   variables: {
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useBoardJoinButtonMemberQuery(
  baseOptions: TrelloQueryHookOptions<
    BoardJoinButtonMemberQuery,
    BoardJoinButtonMemberQueryVariables
  > &
    (
      | { variables: BoardJoinButtonMemberQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const isQuickLoading = useQuickLoad({
    waitOn: baseOptions?.waitOn || ['None'],
    document: BoardJoinButtonMemberDocument,
    skip: baseOptions?.skip,
  });
  const options = {
    ...defaultOptions,
    ...baseOptions,
    skip: isQuickLoading || baseOptions?.skip,
  };
  const result = Apollo.useQuery<
    BoardJoinButtonMemberQuery,
    BoardJoinButtonMemberQueryVariables
  >(BoardJoinButtonMemberDocument, options);
  // reconstruct result because modifying the useQuery result actually changes apollo behavior because of memoization
  const trelloResult = { ...result };
  if (isQuickLoading) {
    trelloResult.loading = true;
  }

  return trelloResult;
}
export function useBoardJoinButtonMemberLazyQuery(
  baseOptions?: TrelloLazyQueryHookOptions<
    BoardJoinButtonMemberQuery,
    BoardJoinButtonMemberQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    BoardJoinButtonMemberQuery,
    BoardJoinButtonMemberQueryVariables
  >(BoardJoinButtonMemberDocument, options);
}
export function useBoardJoinButtonMemberSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | TrelloSuspenseQueryHookOptions<
        BoardJoinButtonMemberQuery,
        BoardJoinButtonMemberQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    BoardJoinButtonMemberQuery,
    BoardJoinButtonMemberQueryVariables
  >(BoardJoinButtonMemberDocument, options);
}
export type BoardJoinButtonMemberQueryHookResult = ReturnType<
  typeof useBoardJoinButtonMemberQuery
>;
export type BoardJoinButtonMemberLazyQueryHookResult = ReturnType<
  typeof useBoardJoinButtonMemberLazyQuery
>;
export type BoardJoinButtonMemberSuspenseQueryHookResult = ReturnType<
  typeof useBoardJoinButtonMemberSuspenseQuery
>;
export type BoardJoinButtonMemberQueryResult = Apollo.QueryResult<
  BoardJoinButtonMemberQuery,
  BoardJoinButtonMemberQueryVariables
>;
